import React from 'react';
import logo from '../../assets/logo.jpg';
import { useApp } from '../../context/AppContext';
import './Footer.css';

export default function Footer() {
  const { data } = useApp();
  const year = new Date().getFullYear();
  return (
    <footer>
      <div className="footer-grid">
        <div className="fb">
          <a href="#accueil" className="fb-logo">
            <img src={logo} alt="" />
            <span>KOTOS<span className="gold">TECH</span></span>
          </a>
          <p>{data.factureInfo?.split('\n')[0] || 'Votre partenaire technologique de confiance au Bénin et en Afrique depuis 2011.'}</p>
          <div className="frccm">
            RCCM N° {data.contact.rccm} · JEHOVA-JIRE MULTI-SERVICES<br />
            IFU: {data.contact.ifu} · {data.contact.address}<br />
            www.kotostechnology.com · {data.contact.email}
            {data.contact.email2 ? <> · {data.contact.email2}</> : null}
          </div>
        </div>
        <div className="fcol">
  <h4>Services</h4>
  <ul>
    {data.domaines.map(d => (
      <li key={d.id}><a href="#services">{d.name}</a></li>
    ))}
    {/* Digitalisation ajouté après les domaines */}
    <li><a href="#digitalisation">🌐 Digitalisation d'Entreprises</a></li>
  </ul>
</div>
<div className="fcol">
  <h4>Formations</h4>
  <ul>{data.formations.map(f => <li key={f.id}><a href="#formations">{f.title}</a></li>)}</ul>
</div>
<div className="fcol">
  <h4>Liens utiles</h4>
  <ul>
    <li><a href="#boutique">🛒 KotosShop</a></li>
    <li><a href="#digitalisation">🌐 Digitalisation</a></li>
    <li><a href="#documents">Documents PDF</a></li>
    <li><a href="#immobilier">Immobilier</a></li>
    <li><a href="#contact">Contact</a></li>
    <li><a href="https://www.kotostechnology.com" target="_blank" rel="noreferrer">Site officiel</a></li>
  </ul>
</div>
      </div>
      <div className="fbot">
        <p>© {year} KOTOSTECHNOLOGY – JEHOVA-JIRE MULTI-SERVICES. Tous droits réservés.</p>
        <p style={{ color: 'var(--primary)' }}>Excellence · Innovation · Performance</p>
      </div>
    </footer>
  );
}
